var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4lvngbv1ga)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.113 25.111-4.131 3.799a19.76 19.76 0 0 1-7.32 4.036l1.096 5.114a1.703 1.703 0 0 0 2.502 1.126l6.65-3.75a5.169 5.169 0 0 0 2.342-5.627l-1.139-4.698zm-17.831-9.955 3.557-4.223-4.436-1.07a4.73 4.73 0 0 0-5.767 2.311l-3.747 6.641a1.703 1.703 0 0 0 1.126 2.502l5.233 1.122a21.946 21.946 0 0 1 4.034-7.283zm16.123.069a2.555 2.555 0 1 0 0-5.11 2.555 2.555 0 0 0 0 5.11zM6.712 40.23c-.818.328-1.63-.484-1.301-1.301l3.749-9.33c1.07-2.661 4.511-3.365 6.54-1.336l1.677 1.677c2.029 2.029 1.325 5.47-1.337 6.54l-9.328 3.75z",
    fill: "#174CC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.397 3.722a1.704 1.704 0 0 0-1.214-1.214 19.156 19.156 0 0 0-19.446 6.17l-5.456 6.478a22.03 22.03 0 0 0-4.979 11.428 1.705 1.705 0 0 0 .485 1.424l5.28 5.28a1.702 1.702 0 0 0 1.351.492 20.174 20.174 0 0 0 11.563-4.87l6.238-5.736a19.079 19.079 0 0 0 6.178-19.452zm-9.992 11.502a2.555 2.555 0 1 1 0-5.109 2.555 2.555 0 0 1 0 5.11z",
    fill: "#5388FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4lvngbv1ga"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h46v46H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.7d8f4e2bc53244956af6fbe044dd4d14.svg";
export { ForwardRef as ReactComponent };